import { dictionariesApi, DictionaryApi } from "api/dictionaries/dictionariesApi";
import { useDictionaries } from "api/hooks";
import {
  AdminResourceDeleteModal,
  AdminSearchInput,
  FiltersBackground,
  PageHeader,
  PageMain,
} from "components/molecules";
import { DICTIONARY_TYPES_NAME, routes } from "consts";
import {
  TanTable,
  TanTableColumn,
  useFilters,
  usePagination,
  useSorting,
} from "components/molecules";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDeleteResourceActions } from "utils/store";

export const DictionariesPage = (): JSX.Element => {
  const { setDeleteResource } = useDeleteResourceActions();

  const { searchPhrase, filter, setSearchPhrase } = useFilters();
  const { limit, skip, onPaginationChange, pagination } = usePagination();
  const { sorting, onSortingChange, fieldWithOrder } = useSorting();
  const { isLoading, isFetching, dictionaries, total, invalidate } = useDictionaries(
    skip,
    limit,
    searchPhrase,
    filter,
    fieldWithOrder,
  );

  useEffect(() => {
    invalidate();
  }, [sorting, pagination, searchPhrase, filter]);

  const navigate = useNavigate();
  const columns = React.useMemo<TanTableColumn<DictionaryApi>[]>(
    () => [
      {
        id: "id",
        header: "ID",
        accessorKey: "id",
        enableColumnFilter: false,
        size: 10,
      },
      {
        id: "name",
        header: "Nazwa",
        accessorKey: "name",
        enableColumnFilter: false,
      },
      {
        id: "type",
        header: "Typ",
        accessorKey: "Typ",
        enableColumnFilter: false,
        cell: (cell) => DICTIONARY_TYPES_NAME[cell.row.original.type as 1 | 2],
      },
    ],
    [],
  );
  return (
    <PageMain>
      <PageHeader
        button={{
          title: "Dodaj +",
          onClick: () => navigate(routes.DICTIONARIES_ADD),
        }}
      >
        Słowniki
      </PageHeader>
      <FiltersBackground className="mb-4">
        <div className="flex flex-wrap items-center gap-2">
          <AdminSearchInput onSearch={(sp) => setSearchPhrase(sp)} className="mt-2 self-end" />
        </div>
      </FiltersBackground>
      <TanTable
        data={dictionaries}
        columns={columns}
        loading={isLoading}
        fetching={isFetching}
        total={total}
        onPaginationChange={onPaginationChange}
        onSortingChange={onSortingChange}
        pagination={pagination}
        sorting={sorting}
        onDelete={(x) => setDeleteResource(x.id)}
        onRowClick={(x) => navigate(routes.DICTIONARIES_EDIT(x.id))}
      />

      <AdminResourceDeleteModal
        title="Usuń słownik"
        description="Jesteś pewien że chcesz usunąć słownik?"
        onSuccessDelete={() => invalidate()}
        deleteAction={dictionariesApi.delete}
      />
    </PageMain>
  );
};
